import React from "react";
import { Alert, Button, Stack, Typography } from "@mui/material";
import { formatMatchIdentity } from "components/common/matchIdentity";

export default function SchedulingAnchorConflicts({ conflicts, intl, onEditMatch, disabled, proposal = false, advisory = false }) {
  if (!conflicts.length) return null;
  const message = (id, values) => intl.formatMessage({ id }, values);
  return <Alert severity={advisory ? "warning" : "error"} sx={{ mt: 2 }}>
    <Typography fontWeight="bold">{message(advisory ? "scheduling.warnings.title" : proposal ? "scheduling.proposal.title" : "scheduling.anchors.title")}</Typography>
    <Typography variant="body2">{message(advisory ? "scheduling.warnings.help" : proposal ? "scheduling.proposal.help" : "scheduling.anchors.help")}</Typography>
    <Stack spacing={2} sx={{ mt: 2 }}>
      {conflicts.map((conflict, index) => <Stack key={`${conflict.code}:${index}`} spacing={1}>
        <Typography>{message(`scheduling.${proposal ? "proposal" : "anchors"}.${conflict.code}`)}</Typography>
        {conflict.matches.map((match) => <Button key={match.match_id} color="inherit" variant="outlined" size="small"
          disabled={disabled} onClick={() => onEditMatch(match.match_id)}>
          {formatMatchIdentity(match, message)} · {message("scheduling.anchors.review")}
        </Button>)}
      </Stack>)}
    </Stack>
  </Alert>;
}
